import {HttpError} from '@/domain/repository/jsonHttp';

const GENERIC_ERROR_KEY = 'unexpectedError';

export class UserFacingError extends Error {
  constructor(public translationKeys: Array<string>) {
    super();
  }
}

export const withErrorHandling = async <T, >(supplier: () => Promise<T>, options?: { genericErrorKey?: string }) => {
  try {
    return await supplier();
  } catch (e) {
    console.error(e);
    if (e instanceof HttpError) {
      if (e.businessErrorCodes?.length) {
        throw new UserFacingError(
          e.businessErrorCodes.map(code => `businessErrorCodes.${code}`)
        );
      } else {
        throw new UserFacingError([options?.genericErrorKey ?? GENERIC_ERROR_KEY]);
      }
    }
    throw new UserFacingError([options?.genericErrorKey ?? GENERIC_ERROR_KEY]);
  }
};

export const getErrorTranslationKeys = (error: unknown): Array<string> => {
  if (error instanceof UserFacingError) {
    return error.translationKeys;
  } else {
    return [GENERIC_ERROR_KEY];
  }
};
